import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseDateInput = {
  backgroundColor: css`var(--cse-date-input-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-date-input-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-date-input-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-date-input-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-date-input-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-date-input-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-date-input-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-date-input-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-date-input-color-disabled, ${csFormControl.colorDisabled})`,
  fontSize: css`var(--cse-date-input-font-size, ${csFormControl.fontSize})`,
  fontFamily: css`var(--cse-date-input-font-family, ${csFormControl.fontFamily})`,
  height: css`var(--cse-date-input-height, ${csFormControl.height})`,
  paddingInline: css`var(--cse-date-input-padding-x, ${csFormControl.paddingInline})`,
  paddingBlock: css`var(--cse-date-input-padding-y, ${csFormControl.paddingBlock})`,
  outlineFocus: css`var(--cse-date-input-outline-focus, ${csFormControl.outlineFocus})`,
}

export const style: CSSResult = css`
  .cse-date-input {
    background: ${cseDateInput.backgroundColor};
    border-width: ${cseDateInput.borderWidth};
    border-style: solid;
    border-color: ${cseDateInput.borderColor};
    border-radius: ${cseDateInput.borderRadius};
    color: ${cseDateInput.color};
    display: block;
    font-size: ${cseDateInput.fontSize};
    font-family: ${cseDateInput.fontFamily};
    width: 100%;
    height: ${cseDateInput.height};
    padding-block: ${cseDateInput.paddingBlock};
    padding-inline: ${cseDateInput.paddingInline};
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color, background-color, border-color;
  }

  .cse-date-input.disabled {
    background-color: ${cseDateInput.backgroundColorDisabled};
    color: ${cseDateInput.colorDisabled};
  }

  .cse-date-input.valid-error {
    border-color: ${cseDateInput.borderColorError};
  }

  .cse-date-input.valid-success {
    border-color: ${cseDateInput.borderColorSuccess};
  }

  .cse-date-input:focus-visible {
    outline: ${cseDateInput.outlineFocus};
  }
`
